import { getApiClient, getRequestHeaders } from './zodios-client';
import type { 
  Tenant, 
  ApiKey, 
  CreateTenantRequest, 
  CreateApiKeyRequest,
  PaginationParams,
  LinkListResponse 
} from '@/types';

export const adminService = {
  // Tenant Management
  async createTenant(data: CreateTenantRequest): Promise<Tenant> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.createTenant(data, { headers });
  },

  async listTenants(): Promise<Tenant[]> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.listTenants( { headers });
  },

  // API Key Management
  async createTenantApiKey(tenantId: string, data: CreateApiKeyRequest): Promise<ApiKey & { apiKey: string }> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.createApiKey(data, { 
      params: { tenantId }, 
      headers
    });
  },

  async listTenantApiKeys(tenantId: string): Promise<ApiKey[]> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.listApiKeys({ params: { tenantId }, headers });
  },



  async updateTenantApiKey(tenantId: string, keyId: string, isActive: boolean): Promise<{ message: string }> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.updateApiKey({ isActive }, { 
      params: { tenantId, keyId },
      headers
    });
  },



  async deleteTenantApiKey(tenantId: string, keyId: string): Promise<{ message: string }> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.deleteApiKey(undefined, { 
      params: { tenantId, keyId },
      headers
    });
  },

  async createAdminApiKey(data: CreateApiKeyRequest): Promise<ApiKey & { apiKey: string }> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.createAdminApiKey(data, { headers });
  },

  async listAdminApiKeys(): Promise<ApiKey[]> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.listAdminApiKeys({ headers });
  },



  async updateAdminApiKey(keyId: string, isActive: boolean): Promise<{ message: string }> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.updateAdminApiKey({ isActive }, { params: { keyId }, headers });
  },

  async deleteAdminApiKey(keyId: string): Promise<{ message: string }> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.deleteAdminApiKey(undefined, { params: { keyId }, headers });
  },

  async getAnalyticsOverview(): Promise<{
    totalClicks: number;
    totalLinks: number;
    topLinks: Array<{
      shortCode: string;
      title?: string;
      clickCount: number;
      tenantId: string;
      tenantName?: string;
    }>;
    tenantSummary: Array<{
      tenantId: string;
      tenantName: string;
      linkCount: number;
      totalClicks: number;
    }>;
  }> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.getAnalyticsOverview({ headers });
  },

  // Global Link Management
  async listGlobalLinks(params: PaginationParams = {}): Promise<LinkListResponse> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.adminListLinks({ queries: { query: params }, headers });
  },

  async getGlobalTopLinks(limit: number = 10): Promise<LinkListResponse> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.adminListLinks({
      queries: { query: { limit, clickOrder: 'desc' } },
      headers
    });
  }
  ,
  async deactivateTenant(tenantId: string): Promise<{ message: string }> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.deactivateTenant(undefined, { params: { tenantId }, headers });
  }
};
